import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { FiEdit, FiTrash } from 'react-icons/fi';
// eslint-disable-next-line no-unused-vars
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';
import ResponsiveDataList from '../components/common/ResponsiveDataList';
import MobileCard from '../components/common/MobileCard';

const emptyPeriode = { periode: '', abrev: '', ordre: '' };

const PeriodesPage = () => {
 // const { user } = useAuth();
  const [periodes, setPeriodes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyPeriode);

  useEffect(() => {
    fetchPeriodes();
  }, []);

  const fetchPeriodes = async () => {
    const res = await api.get('/periodes');
    setPeriodes(res.data.data || []);
  };

  const handleAdd = () => {
    setEditing(null);
    setForm(emptyPeriode);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditing(item);
    setForm({ periode: item.periode, abrev: item.abrev, ordre: item.ordre });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Supprimer cette période ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
    });
    if (result.isConfirmed) {
      await api.delete(`/periodes/${id}`);
      fetchPeriodes();
      Swal.fire('Supprimé !', 'La période a été supprimée.', 'success');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditing(null);
    setForm(emptyPeriode);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.periode) {
      await Swal.fire({ icon: 'error', title: 'Erreur', text: 'Le nom de la période est obligatoire.' });
      return;
    }
    if (editing) {
      await api.put(`/periodes/${editing.id}`, form);
    } else {
      await api.post('/periodes', form);
    }
    fetchPeriodes();
    setShowModal(false);
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Périodes</h1>
        <ConditionalButton
          entity="periodes"
          permission="create"
          className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
          onClick={handleAdd}
        >
          Nouvelle période
        </ConditionalButton>
      </div>
      <ResponsiveDataList
        isLoading={false}
        isEmpty={periodes.length === 0}
        emptyMessage="Aucune période"
        mobileCards={periodes.map((item) => (
          <MobileCard
            key={item.id}
            title={item.periode}
            fields={[
              { label: 'Abréviation', value: item.abrev },
              { label: 'Ordre', value: item.ordre },
            ]}
            actions={
              <ConditionalActions
                entity="periodes"
                onEdit={() => handleEdit(item)}
                onDelete={() => handleDelete(item.id)}
                editIcon={FiEdit}
                deleteIcon={FiTrash}
                className="flex space-x-2"
              />
            }
          />
        ))}
      >
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nom</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Abréviation</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ordre</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {periodes.length === 0 ? (
              <tr>
                <td colSpan="4" className="px-6 py-4 text-center text-gray-500">Aucune période</td>
              </tr>
            ) : (
              periodes.map((item) => (
                <tr key={item.id}>
                  <td className="px-6 py-4">{item.periode}</td>
                  <td className="px-6 py-4">{item.abrev}</td>
                  <td className="px-6 py-4">{item.ordre}</td>
                  <td className="px-6 py-4 text-right">
                    <ConditionalActions
                      entity="periodes"
                      onEdit={() => handleEdit(item)}
                      onDelete={() => handleDelete(item.id)}
                      editIcon={FiEdit}
                      deleteIcon={FiTrash}
                      className="flex space-x-2"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </ResponsiveDataList>
      <Modal
        isOpen={showModal}
        onRequestClose={handleModalClose}
        contentLabel="Période"
        ariaHideApp={false}
        style={{
          content: {
            maxWidth: '400px',
            width: '100%',
            margin: 'auto',
            height: '380px',
            borderRadius: 12,
            overflow: 'hidden',
            padding: 0
          }
        }}
      >
        <form onSubmit={handleSubmit} className="p-6">
          <h2 className="text-lg font-semibold mb-4">{editing ? 'Modifier' : 'Nouvelle'} période</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Nom *</label>
            <input
              type="text"
              name="periode"
              value={form.periode}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Abréviation</label>
            <input
              type="text"
              name="abrev"
              value={form.abrev}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              maxLength={10}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Ordre</label>
            <input
              type="number"
              name="ordre"
              value={form.ordre}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={handleModalClose} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Annuler</button>
            <ConditionalButton
              entity="periodes"
              permission={editing ? "update" : "create"}
              type="submit"
              className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700"
            >
              {editing ? 'Enregistrer' : 'Créer'}
            </ConditionalButton>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default PeriodesPage;
